export default __webpack_public_path__ + "static/media/circle.2e9e64af.svg";